export default __webpack_public_path__ + "static/media/Declaration of Independence_09.16fccd92.jpg";